import { API_BASE, apiSlice } from '@/redux/api-slice'

const url = API_BASE + 'Notification'

export const notifyMeApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    AddNotification: build.mutation<void, NewNotificationParams>({
      query: (body) => ({
        method: 'post',
        url: url + '/notification',
        body,
      }),
    }),
  }),
})

type NewNotificationParams = {
  searchString: string
}

export default notifyMeApi
export const { useAddNotificationMutation } = notifyMeApi
